module.exports = __webpack_public_path__ + "img/invoice-gray.1ce35b25.svg";